import { Injectable } from '@angular/core';

import { LinkTarget } from '../../shared/constants/link-target.enum';
import { InstrumentationService } from '../../shared/instrumentation/instrumentation.service';
import { ErrorDialogService } from '../../shared/services/error-dialog.service';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { PwaUrlLauncherService } from './pwa-url-launcher.service';

/**
 * Windows protocol launcher.
 */
@Injectable()
export class UwpUrlLauncherService extends PwaUrlLauncherService {

    constructor(capabilitiesService: CapabilitiesService, errorDialogService: ErrorDialogService, instrumentationService: InstrumentationService) {
        super(capabilitiesService, errorDialogService, instrumentationService);
    }

    public supportsProtocol(protocol: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const uri = this.getUri(protocol);
            if (!uri) {
                reject('Invalid protocol');
                return;
            }

            Windows.System.Launcher.queryUriSupportAsync(uri, Windows.System.LaunchQuerySupportType.uri, Windows.ApplicationModel.Package.current.id.familyName).then( status => {
                resolve(status === Windows.System.LaunchQuerySupportStatus.available);
            }, error => {
                reject(`QueryUriSupportError: ${error}`);
            });
        });
    }

    public async launchUrl(url: string, _linkTarget?: LinkTarget, _width?: number, _height?: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const uri = this.getUri(url);
            if (!uri) {
                reject('Invalid Url');
                return;
            }

            Windows.System.Launcher.launchUriAsync(uri).then(success => {
                if (!success) {
                    reject('Launch Uri Failed');
                    return;
                }
                resolve();
            }, () => {
                reject('Launch Uri Error');
            });
        });
    }

    private getUri(url: string): Windows.Foundation.Uri {
        try {
            return new Windows.Foundation.Uri(url);
        } catch {
            return null;
        }
    }
}
